import React from "react";
import { Box, Typography, Button } from "@mui/material";

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  actionLabel,
  onAction,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      py={8}
    >
      {icon && (
        <Box
          sx={{
            fontSize: 64,
            color: "grey.300",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 2,
            "& .MuiSvgIcon-root": {
              fontSize: "inherit",
            },
          }}
        >
          {icon}
        </Box>
      )}
      <Typography variant="h6" color="text.secondary">
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {description}
        </Typography>
      )}
      {actionLabel && onAction && (
        <Button
          variant="contained"
          size="medium"
          onClick={onAction}
          sx={{ mt: 3, px: 3, py: 1 }}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;
